import {
  ShaqFAQ,
} from '../models/Objects';
import { StoreState } from './states';

export const VUEX_MUTATION_ADD_FAQS = 'addFAQs';
export const VUEX_MUTATION_SET_CURRENT_FAQ = 'setCurrentFAQ';

export const mutations = {
  setCurrentFAQ (state: StoreState, faq: ShaqFAQ) {
   state.currentFAQ = faq;
  },
  addFAQs (state: StoreState, faqs: ShaqFAQ[]) {
    faqs.forEach(faq =>
      state.faqs.set(faq.id, faq),
    );
  },
};
